/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The AirGrip component
 *
 * @author Thais Watanabe
 */
const AirGrip = (props) => {
  const {
    turbineInspection,
    title,
    inspectionModel,
    result,
    openEdit,
    openObs,
    isPastInspection,
    inspection,
    lastTurbineInspections,
  } = props;

  return (
    <Table>
      <thead>
        <tr>
          <ColHeader id={inspectionModel?.name} className="w-10 text-center print:hidden">
            {!isPastInspection && (
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={inspectionModel}
                turbineInspection={turbineInspection}
                selectedResult={result}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
            )}
          </ColHeader>
          <ColHeader className="text-center" colSpan={3}>
            {title}
          </ColHeader>
        </tr>
        <tr>
          <ColHeader className="text-center" colSpan={4}>
            ローターの下側(6時位置)に来ているブレードNoの記載：No. {result?.childrenResults[0] ?? "-"}
          </ColHeader>
        </tr>
        <tr>
          <ColHeader className="text-center print:hidden"></ColHeader>
          <ColHeader className="text-center">位置</ColHeader>
          <ColHeader className="text-center">箇所</ColHeader>
          <ColHeader className="text-center">エアギャップ</ColHeader>
        </tr>
      </thead>
      <TableBody>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center" rowSpan={3}>
            12時
          </Col>
          <Col className="text-center">左</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[1] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[1].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[1] ?? "-",
                1
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">中央</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[2] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[2].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[2] ?? "-",
                2
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">右</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[3] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[3].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[3] ?? "-",
                3
              )}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center" rowSpan={3}>
            6時
          </Col>
          <Col className="text-center">左</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[4] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[4].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[4] ?? "-",
                4
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">中央</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[5] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[5].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[5] ?? "-",
                5
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">右</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[6] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[6].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[6] ?? "-",
                6
              )}
            />
          </Col>
        </tr>
      </TableBody>
    </Table>
  );
};

export default AirGrip;
